import { Button } from "@/components/ui/button";
import { useTheme } from "@/context/ThemeContext";
import { FaMoon, FaSun } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  className?: string;
  variant?: "default" | "ghost" | "outline" | "secondary" | "destructive" | "link";
  size?: "default" | "sm" | "lg" | "icon";
}

const ThemeToggle = ({
  className,
  variant = "ghost",
  size = "icon"
}: ThemeToggleProps) => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggleTheme}
      className={cn(
        "rounded-full w-8 h-8 flex items-center justify-center transition-all duration-300 hover:scale-110 hover:rotate-12 active:scale-95",
        className
      )}
      aria-label={theme === "light" ? t("profile.darkMode") : t("profile.lightMode")}
    >
      {theme === "light" ? (
        <FaMoon className="h-4 w-4 transition-transform duration-300" />
      ) : (
        <FaSun className="h-4 w-4 transition-transform duration-300 rotate-0 hover:rotate-180" />
      )}
    </Button>
  );
};

export default ThemeToggle;
